<template>
  <form-field v-bind="$attrs" :title="title" is-link :is-require="isRequire" @click="onClick">
    <div v-if="!value && isPublish">
      长期有效
    </div>
    <div v-else-if="!value" class="placeholder">
      请选择{{ title }}
    </div>
    <div v-else>
      {{ value }}
    </div>
    <van-popup v-model="isShow" position="bottom" get-container="body">
      <van-datetime-picker v-model="currentDate" cancel-button-text="清空" :type="type" :min-date="minDate" :max-date="maxDate" @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>
  </form-field>
</template>

<style lang="less" scoped>
.placeholder {
  font-size: 32px;
  color: #bbb;
}
</style>

<script>
import dayjs from 'dayjs';
export default {
  name: 'FormDatetime',
  props: {
    value: String,
    title: String,
    isRequire: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'year-month',
    },
    minDate: {
      type: Date,
      default() {
        return new Date(1960, 0, 1);
      },
    },
    maxDate: {
      type: Date,
    },
    isPublish: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShow: false,
      currentDate: new Date(),
    };
  },
  watch: {
    isShow(val) {
      if (val) {
        this.currentDate = new Date(this.value) || new Date();
      }
    },
  },
  methods: {
    onClick() {
      this.isShow = true;
    },
    onConfirm(value) {
      const formatStr = this.type === 'year-month' ? 'YYYY-MM' : 'YYYY-MM-DD';
      const currentDateStr = dayjs(value).format(formatStr);
      this.$emit('input', currentDateStr);
      this.isShow = false;
    },
    onCancel() {
      this.$emit('input', '');
      this.isShow = false;
    },
  },
};
</script>
